import {GenericInput} from '@hm/fundamental'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {handleNoSpecialCharacters} from '../../../common/utils/handleNoSpecialCharacters'
import {useTranslation} from '../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../Skeleton/UserInformationInputSkeleton'

import {UserInformationProps} from './types'

export const UserNameInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isLoading,
  name
}: UserInformationProps<T>) => {
  const {t} = useTranslation()
  const errors = formMethods.formState.errors

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      rules={{
        validate: (value) => handleNoSpecialCharacters(value, t)
      }}
      render={({field, fieldState}) => (
        <GenericInput
          {...field}
          data-test-id={`userInformationForm-${field.name}`}
          label={t('userInformationForm.name')}
          isReadOnly={readonlyMode}
          error={errors[name]?.message?.toString()}
          isTouched={fieldState.isTouched}
        />
      )}
    />
  )
}
